import React from 'react';

import { useQuery } from '@apollo/client';
import { Text } from '@opendoor/bricks/core';

import {
  ParnDetails,
  ParnDetailsVariables,
} from '../../graphql/athena/queries/__generated__/ParnDetails';
import { PARN_DETAILS_QUERY } from '../../graphql/athena/queries/ParnDetails';
import { useAthenaSessionQuery } from '../../graphql/athena/queries/Session';
import { PrivateRouteComponent } from '../PrivateRoute';
import Header from './NavigationBar/Header';
import { ParnDashboardLayout } from './ParnDashboardLayout';
import { ParnLeadCardWrapper } from './ParnLeadCardWrapper';
import { sortPARNDetailsByState } from './parnUtils';

const PARN_DASHBOARD_NAME = 'partner agent referral network dashboard';

export const ParnDashboard: React.FC & PrivateRouteComponent = () => {
  const { customerUuid, data, loading, error } = useAthenaSessionQuery();

  const {
    loading: parnDetailsLoading,
    error: parnDetailsError,
    data: parnDetailsData,
  } = useQuery<ParnDetails, ParnDetailsVariables>(PARN_DETAILS_QUERY, {
    context: {
      clientName: 'athena',
    },
    skip: !customerUuid,
    variables: {
      agentCustomerUuid: customerUuid ?? '',
    },
    errorPolicy: 'all',
  });

  if (loading || error || !data) return null;
  if (parnDetailsLoading) return <p>Loading...</p>;
  if (parnDetailsError)
    return <p>Sorry, we encountered an issue fetching the details for this page.</p>;

  const parnDetailsFromServer =
    parnDetailsData?.odProtosListingsServicesPartneragentreferralnetwork.getPARNDetails
      ?.parnDetails ?? [];

  const sortedPARNDetails = sortPARNDetailsByState(parnDetailsFromServer);
  const parnLeadCards = sortedPARNDetails.map((parnDetails) => {
    return (
      <ParnLeadCardWrapper
        key={parnDetails.parn?.sellDirectLeadToken}
        parnDetails={parnDetails}
        agentCustomerUuid={customerUuid ?? ''}
      />
    );
  });
  return (
    <>
      <Header />
      <ParnDashboardLayout>
        <Text size={'s3'} fontWeight={'semibold'} data-testid="parn-review-leads-heading">
          Review your leads
        </Text>
        {parnLeadCards}
      </ParnDashboardLayout>
    </>
  );
};

ParnDashboard.dashboardName = PARN_DASHBOARD_NAME;
ParnDashboard.isAuthorized = () => true;

export default ParnDashboard;
